export const paging = {
  data() {
    return {
      from: 0,
      page: 1,
      pageSize: 100,
      pageSizes: [100, 250, 500]
    }
  },
  watch: {
    // search: {
    //   handler() {
    //     this.page = 1
    //     this.tableChanged()
    //   }
    // },
    pageSize: {
      handler() {
        if (this.page > 1) {
          return (this.page = 1)
        }
        this.tableChanged()
      }
    },
    page: {
      handler(newValue) {
        if (newValue > 1) {
          this.from = newValue * this.pageSize - this.pageSize
          this.tableChanged()
        } else {
          this.from = 0
          this.tableChanged()
        }
      }
    }
  },
  computed: {
    disablePrevious() {
      return (this.page - 1) * this.pageSize === 0
    },
    disableNext() {
      return this.items.length < this.pageSize
    },
  },
  methods: {
    previous() {
      this.page = this.page - 1
      if (this.page < 1) {
        this.page = 1
      }
      this.$el.querySelector('.v-data-table__wrapper').scrollTop = 0;
    },
    next() {
      this.page = this.page + 1
      this.$el.querySelector('.v-data-table__wrapper').scrollTop = 0;
    },
    setStartEnd(){
      this.start = (this.page - 1) * this.pageSize
      this.end = this.start + this.pageSize
    },
    tableChange(searchFunc) {
      return function () {
        searchFunc()
      }
    },
    submitSearch(searchFunc) {
      return function () {
        searchFunc()
      }
    },
  }
}
